import { useSearchComponentStateSelector } from "@/redux/modules/value/search/search.selectors";
import { SearchComponentOfType } from "@/utils/search/types/searchComponent";

import { filterFacets } from "../facet.filters";
import { DelegatingFacet } from "./facet/delegatingFacet.container";

type FacetsComponentProps = {
    component: SearchComponentOfType<"FACETS">;
};

const FacetsComponent = ({ component }: FacetsComponentProps) => {
    const facetsComponentState = useSearchComponentStateSelector(component);

    if (!facetsComponentState?.facets?.length) return null;

    return (
        <>
            {facetsComponentState.facets
                .filter(filterFacets)
                .sort((a, b) => a.order - b.order)
                .map((facet) => (
                    <DelegatingFacet
                        key={facet.name + facet.order}
                        facet={facet}
                        component={component}
                    />
                ))}
        </>
    );
};

export { FacetsComponent };
